import { render, staticRenderFns } from "./PaginaInicio.vue?vue&type=template&id=44aaed6e&scoped=true&"
import script from "./PaginaInicio.vue?vue&type=script&lang=js&"
export * from "./PaginaInicio.vue?vue&type=script&lang=js&"
import style0 from "./PaginaInicio.vue?vue&type=style&index=0&id=44aaed6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44aaed6e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VContainer,VIcon,VImg,VRow,VSelect})
